import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DealerHolidayBusinessService } from '../../business-services/dealer-holiday.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { CustomPaggerService } from './../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from './../../../../../Autofacets-Core/src/app/utils/constant';
import { DealerHolidayViewModel } from './../../business-entities/dealer-holiday-list-view-model';
import { SelectListItemViewModel } from './../../business-entities/select-list-item-view-model';
import { AddDealerHolidayComponent } from './add-dealer-holiday/add-dealer-holiday.component';
import { EditDealerHolidayComponent } from './edit-dealer-holiday/edit-dealer-holiday.component';

@Component({
  selector: 'app-dealer-holiday',
  templateUrl: './dealer-holiday.component.html',
})
export class DealerHolidayComponent implements OnInit, OnDestroy {
  dealerHolidayList: DealerHolidayViewModel[];
  dealerList: Array<SelectListItemViewModel>;
  paginationSub: Subscription;
  total$: Observable<number>;
  popupCloseResult = false;
  selectedDealerId: string = '';
  dealerSelected: string = '';
  userRoleRightsDetails: UserRoleMenu;
  dealerId:string='';

  focus$ = new Subject<string>();
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private dealerHolidayBusinessService: DealerHolidayBusinessService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private userService: UserDataService,
    public dealerBusinessService: DealerBusinessService,
    config: NgbModalConfig
  ) {

    this.pService.pageSize = 10;
    this.pService.searchby = ['id', 'name', 'dealerName', 'startDate', 'endDate'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
    this.pService.dataSource = [];
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.getUserDealers();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.DealerHoliday);
  if ((this.dealerHolidayBusinessService.isEdit || this.dealerHolidayBusinessService.isAdd) && this.dealerHolidayBusinessService.dealerId) {
    this.dealerSelected = this.dealerList.find(x => x.value == this.dealerHolidayBusinessService.dealerId).text;
  this.dealerHolidayBusinessService.isEdit = false;
  this.dealerHolidayBusinessService.isAdd = false;
  }
  else {
    this.dealerHolidayBusinessService.dealerId = '';
  }
    this.dealerHolidayBusinessService.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.getDealerHolidayList(this.dealerHolidayBusinessService.dealerId);
}
  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerHolidayBusinessService.dealerList = this.dealerList;
      if(this.dealerList.length === 1){
        this.dealerId = this.dealerList[0].value;
      }
    })
  }

  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  setselectedDealerId(dealerId: string) {
    this.selectedDealerId = dealerId;
  }

  onDealerSelected(dealerId: string) {
    this.selectedDealerId= dealerId ?? '' ;
    this.dealerId = dealerId;
    this.dealerHolidayBusinessService.dealerId = dealerId;
    this.getDealerHolidayList(this.selectedDealerId);
  }


  async getDealerHolidayList(dealerId) {
    this.spinner.show();
    let Id = dealerId ?? '' ;
    await this.dealerHolidayBusinessService.getDealerWiseHolidayList(Id).then((response) => {
      this.pService.dataSource = response;
      if (response.length !== 0) {
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.dealerHolidayList = this.dealerHolidayDataMapper(result);
        });
        this.total$ = this.pService.total$;
        if (Id !== '' && this.dealerList) {
          let dealerId = response[0].dealerId;
          this.dealerSelected = this.dealerList.filter(x => (x.value === dealerId) ? x.text : '')[0].text;
          if (this.selectedDealerId === '0') {
            this.setselectedDealerId(dealerId);
          }
        }
      }
      this.spinner.hide();
    });
  }

  formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        return term === '' ? []
          : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
      })
    )

  setDealer(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();
    this.selectedDealerId = event.item.value;
    this.dealerSelected = event.item.text;
    this.getDealerHolidayList(this.dealerHolidayBusinessService.dealerId);
  }

  handleResultSelected(result) {
    this.search = result;
  }

  checkIfEditable(startDate, endDate) {
    startDate = Utility.getDateStringToDate(startDate);
    endDate = Utility.getDateStringToDate(endDate);
    const todaysDate = new Date();
    return startDate.getTime() >= todaysDate.getTime() && endDate.getTime() >= todaysDate.getTime();
  }

  private dealerHolidayDataMapper(dealerHoliday: DealerHolidayViewModel[]) {
    let supperArray = [];
    if (dealerHoliday && dealerHoliday.length > 0) {

      for (let index = 0; index < dealerHoliday.length; index++) {
        const element = dealerHoliday[index];

        const single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.name = element.name;
        single.dealerName = element.dealerName;
        single.startDate = element.startDate;
        single.endDate = element.endDate;
        single.isEditable = this.checkIfEditable(element.startDate, element.endDate);
        supperArray.push(single);
      }
    }

    return supperArray;
  }
  onAdd() {
    this.dealerHolidayBusinessService.isAdd = true;
    const modalref = this.modalService.open(AddDealerHolidayComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  editDealerHoliday(id: number) {
    this.dealerHolidayBusinessService.dealerHolidayId = id;
    this.dealerHolidayBusinessService.isEdit = true;
    const modalref = this.modalService.open(EditDealerHolidayComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  deleteDealerHoliday(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblNationalHolidays"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(() => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.dealerHolidayBusinessService.deleteDealerHoliday(id).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode) {
            this.getDealerHolidayList(this.dealerHolidayBusinessService.dealerId);
          }
        });
      }
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }
}

